import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate, substractDays, compareAsc } from 'datesHelper.js';
import {
  changeDateByType,
  changeActiveTab,
  fetchTransactionsByFilter,
  setCurrentPage,
  resetToInitialState,
  cancellPayout,
} from 'accountWalletActions.js';
import Pagination from 'Pagination.js';
import Loader from 'Loader.js';
import ModalOpacity from 'ModalOpacity.js';
import ArrowIcon from 'arrow_icon.svg';
import BellIcon from 'bell-icon.svg';
import S from 'StyledAccountWallet.js';

class AccountWallet extends Component {
  state = {
    transactions: [],
    selectedTransactionId: null,
    showConfirmationModal: false,
  };

  componentDidMount = async () => {
    const { fetchTransactionsByFilter, resetToInitialState } = this.props;
    try {
      batch(() => {
        resetToInitialState();
        fetchTransactionsByFilter();
      });
    } catch (error) {
      console.log('fetchTransactionsByFilter:' + error);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.isPending != this.props.isPending &&
      !this.props.isPending &&
      this.props.data
    ) {
      this.prepeareStateFromTransations(this.props.data);
    }
  }

  handleChangeStart = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchTransactionsByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchTransactionsByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchTransactionsByFilter();
    });
  };

  prepeareStateFromTransations = (data) => {
    const transactions = data.map((transaction) => ({ 
      ...transaction, 
      // For initializated withdrawns, tab could be cancelled - open tab on start
      isOpen: transaction.type === 156 && transaction.statusCode === 'INI', 
    }));
    this.setState(() => ({ transactions }));
  };

  toggleDropdown = (id) => {
    const indexOfItem = this.findIndexOfItem(id);
    if (indexOfItem !== -1) {
      const [item] = this.state.transactions.slice(indexOfItem, indexOfItem + 1);
      this.updateTransactionItem(indexOfItem, item);
    }
  };

  findIndexOfItem = (searchId) => {
    return this.state.transactions.findIndex(({ transactionId }) => transactionId == searchId);
  };

  updateTransactionItem = (indexOfItem, item) => {
    this.setState((prevState) => {
      const itemsBeforeIndex = prevState.transactions.slice(0, indexOfItem);
      const itemsAfterIndex = prevState.transactions.slice(indexOfItem + 1);
      const nextState = {
        ...prevState,
        transactions: [...itemsBeforeIndex, { ...item, isOpen: !item.isOpen }, ...itemsAfterIndex],
      };
      return nextState;
    });
  };

  getTransactionStatusClass = (statusCode) => {
    const status = statusCode.toUpperCase();
    switch (status) {
      case 'DEC':
      case 'FLD':
      case 'ERR':
        return 'red';
      case 'SCS':
        return 'green';
      case 'IPR':
      case 'INI':
        return 'gray';
      default:
        return '';
    }
  };

  parseStatus = (status) => {
    return 'transfer_statusList.' + status;
  };

  parseType = (type) => {
    return 'transferTypeList.' + type;
  };

  goPage = (currentPage) => {
    const { fetchTransactionsByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchTransactionsByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountWallet.goPage');
    }
  };

  setStartDate = (days) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const today = new Date();
    const startDate = substractDays(today, days);
    const endDate = days === 1 ? startDate : today;

    batch(() => {
      changeDateByType('startDate', startDate);
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  compareDates = (dateLeft, dateRight) => {
    dateLeft = new Date(formatDate(dateLeft, 'yyyy-MM-dd'));
    dateRight = new Date(formatDate(dateRight, 'yyyy-MM-dd'));
    const result = compareAsc(dateLeft, dateRight);

    if (!result) {
      return true;
    }
    return false;
  };

  openConfirmPopupCancellPayout = (transactionId) => {
    this.setSelectedTransactionId(transactionId);
    this.toggleModal('showConfirmationModal');
  };

  setSelectedTransactionId = (selectedTransactionId) => {
    this.setState((prevState) => {
      return { ...prevState, selectedTransactionId };
    });
  };

  cancellPayoutAction = async (transactionId) => {
    const { fetchTransactionsByFilter, cancellPayout } = this.props;
    try {
      this.toggleModal('showConfirmationModal');

      const config = {
        transactionId,
      };

      await cancellPayout(config);
      fetchTransactionsByFilter();
    } catch (error) {
      console.log('cancellPayoutAction:' + error);
    }
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  findTransactionById = (searchId) => {
    return this.state.transactions.find(({ transactionId }) => transactionId === searchId);
  };

  render() {
    const { isPending, startDate, endDate, data, isNextPageAvailable, currentPage, limit, activeTab } =
      this.props;
    const { showConfirmationModal, selectedTransactionId } = this.state;
    const today = new Date();

    return (
      <S.AccountWallet>
        <ModalOpacity
          isOpen={showConfirmationModal}
          showHeader={false}
          showHeaderIcon={false}
          showHeaderTitle={false}
          showCloseIcon={false}
          padding="10px"
          width="90%"
          toggleOpen={this.toggleModal.bind(this, 'showConfirmationModal')}
          preventCloseOnOverlay={true}
        >
          <S.ConfirmModal>
            <S.BellContainer>
              <S.BellIcon dangerouslySetInnerHTML={{ __html: BellIcon }}></S.BellIcon>
            </S.BellContainer>
            <S.Description>
              {translation('account_wallet_confirmCancelPayoutQuestion')}
            </S.Description>
            <S.BtnsWrapper>
              <S.ButtonAccept onClick={this.cancellPayoutAction.bind(this, selectedTransactionId)}>
                {translation('common_yes')}
              </S.ButtonAccept>
              <S.ButtonCancel onClick={this.toggleModal.bind(this, 'showConfirmationModal')}>
                {translation('common_cancel')}
              </S.ButtonCancel>
            </S.BtnsWrapper>
          </S.ConfirmModal>
        </ModalOpacity>

        <S.WalletFilters>
          <S.WalletFiltersTop>
            <S.WalletFiltersDates>
              <S.Datepicker>
                <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
                <input
                  type="date"
                  value={formatDate(startDate, 'yyyy-MM-dd')}
                  onChange={(event) => this.handleChangeStart(event.target.value)}
                />
                <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
              </S.Datepicker>
              <S.Datepicker>
                <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
                <input
                  type="date"
                  value={formatDate(endDate, 'yyyy-MM-dd')}
                  onChange={(event) => this.handleChangeEnd(event.target.value)}
                />
                <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
              </S.Datepicker>
            </S.WalletFiltersDates>

            <S.WalletFiltersBtns>
              <S.FilterBtn
                isActive={this.compareDates(startDate, today) && this.compareDates(endDate, today)}
                onClick={this.setStartDate.bind(this, 0)}
              >
                {translation('account_wallet_startDateToday')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 1)) &&
                  this.compareDates(endDate, substractDays(today, 1))
                }
                onClick={this.setStartDate.bind(this, 1)}
              >
                {translation('account_wallet_startDateYesterday')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 7)) &&
                  this.compareDates(endDate, today)
                }
                onClick={this.setStartDate.bind(this, 7)}
              >
                {translation('account_wallet_startDate7days')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 30)) &&
                  this.compareDates(endDate, today)
                }
                onClick={this.setStartDate.bind(this, 30)}
              >
                {translation('account_wallet_startDate30days')}
              </S.FilterBtn>
            </S.WalletFiltersBtns>
          </S.WalletFiltersTop>

          <S.WalletFiltersBottom>
            <S.RadioButtons>
              <S.RadioButton>
                <S.RadioButtonInput type="radio" name="transaction-type" defaultChecked={activeTab === "all"} />
                <S.RadioButtonControlIndicator onClick={this.onChangeFilter.bind(this, 'all')} />
                <S.RadioButtonText>{translation('account_wallet_types_all')}</S.RadioButtonText>
              </S.RadioButton>

              <S.RadioButton>
                <S.RadioButtonInput type="radio" name="transaction-type" defaultChecked={activeTab === "deposit"} />
                <S.RadioButtonControlIndicator onClick={this.onChangeFilter.bind(this, 'deposit')} />
                <S.RadioButtonText>
                  {translation('account_wallet_types_deposits')}
                </S.RadioButtonText>
              </S.RadioButton>

              <S.RadioButton>
                <S.RadioButtonInput type="radio" name="transaction-type" defaultChecked={activeTab === "payout"} />
                <S.RadioButtonControlIndicator onClick={this.onChangeFilter.bind(this, 'payout')} />
                <S.RadioButtonText>{translation('account_wallet_types_payouts')}</S.RadioButtonText>
              </S.RadioButton>

              <S.RadioButton>
                <S.RadioButtonInput type="radio" name="transaction-type" defaultChecked={activeTab === "promotion"} />
                <S.RadioButtonControlIndicator onClick={this.onChangeFilter.bind(this, 'promotion')} />
                <S.RadioButtonText>
                  {translation('account_wallet_types_cashback')}
                </S.RadioButtonText>
              </S.RadioButton>
            </S.RadioButtons>
          </S.WalletFiltersBottom>
        </S.WalletFilters>
        <S.WalletTransactions className="wallet-transaction-list">
          {isPending ? (
            <Loader />
          ) : (
            <>
              <S.WalletTransactionsList className="transaction-list">
                <S.FakeTableHead>
                  <div className="wallet-toggle"></div>
                  <div className="wallet-date">{translation('account_wallet_transfers_date')}</div>
                  <div className="wallet-type">{translation('account_wallet_transfers_type')}</div>
                  <div className="wallet-amount">
                    {translation('account_wallet_transfers_amount')}
                  </div>
                  <div className="wallet-status">
                    {translation('account_wallet_transfers_status')}
                  </div>
                </S.FakeTableHead>

                {this.state.transactions?.length > 0 ? (
                  <S.FakeTableBody>
                    {this.state.transactions.map(
                      ({ amount, regDate, type, statusCode, transactionId, referenceId }) => {
                        const { isOpen } = this.findTransactionById(transactionId) ?? {};

                        return (
                          <S.WalletTransactionsListItemWrapper key={transactionId}>
                            <S.WalletTransactionsListItem className="transaction-list-item">
                              <div
                                className="wallet-toggle"
                                onClick={this.toggleDropdown.bind(this, transactionId)}
                              >
                                <S.ArrowIcon
                                  isOpen={isOpen}
                                  dangerouslySetInnerHTML={{ __html: ArrowIcon }}
                                />
                              </div>

                              <div className="wallet-date">
                                <span>{formatDate(regDate, 'dd-MM-yyyy')}</span>
                              </div>

                              <div
                                className="wallet-type"
                                title={translation(this.parseType(type))}
                              >
                                {translation(this.parseType(type))}
                              </div>

                              <div className={`wallet-amount ${amount > 0 ? 'green' : 'red'}`}>
                                {formatMoney(amount)}{' '}
                                <span className="currency">{translation('common_pln')}</span>
                              </div>

                              <div
                                className={`wallet-status ${this.getTransactionStatusClass(
                                  statusCode
                                )}`}
                              >
                                <div className="status-icon"></div>
                              </div>
                            </S.WalletTransactionsListItem>

                            <S.WalletTransactionsListItemDetails isOpen={isOpen}>
                              <div className="details-wrapper">
                                <div className="first-row">
                                  <S.ItemDetailsTitle>
                                    {`${translation(this.parseType(type))}:`} {formatMoney(amount)}{' '}
                                    {translation('common_pln')}
                                  </S.ItemDetailsTitle>
                                </div>

                                {type == 156 && statusCode == 'INI' && (
                                  <div className="middle-row">
                                    <S.CancellPayoutBtn
                                      onClick={this.openConfirmPopupCancellPayout.bind(
                                        this,
                                        referenceId
                                      )}
                                    >
                                      {translation('account_wallet_cancellPayout')}
                                    </S.CancellPayoutBtn>
                                  </div>
                                )}

                                <div className="middle-row">
                                  <div>
                                    <S.ItemDetailsHeader>
                                      {translation('common_id')}
                                    </S.ItemDetailsHeader>
                                    <S.ItemDetailsBody>{transactionId}</S.ItemDetailsBody>
                                  </div>
                                  <div>
                                    <S.ItemDetailsHeader>
                                      {translation('account_wallet_transfers_type')}
                                    </S.ItemDetailsHeader>
                                    <S.ItemDetailsBody>
                                      {translation(this.parseType(type))}
                                    </S.ItemDetailsBody>
                                  </div>
                                  <div>
                                    <S.ItemDetailsHeader>
                                      {translation('account_wallet_transfers_date')}
                                    </S.ItemDetailsHeader>
                                    <S.ItemDetailsBody>
                                      <span>{formatDate(regDate, 'dd-MM-yyyy HH:mm')}</span>
                                    </S.ItemDetailsBody>
                                  </div>
                                </div>
                                <div className="last-row">
                                  <S.ItemDetailsHeader>
                                    {translation('account_wallet_transfers_status')}
                                  </S.ItemDetailsHeader>
                                  <S.ItemDetailsBody
                                    className={this.getTransactionStatusClass(statusCode)}
                                  >
                                    {translation(this.parseStatus(statusCode))}
                                  </S.ItemDetailsBody>
                                </div>
                              </div>
                            </S.WalletTransactionsListItemDetails>
                          </S.WalletTransactionsListItemWrapper>
                        );
                      }
                    )}
                  </S.FakeTableBody>
                ) : (
                  <S.NoResult className="no-result">
                    {translation('account_wallet_transfers_notFound')}
                  </S.NoResult>
                )}
              </S.WalletTransactionsList>

              {data?.length > 0 ? (
                <Pagination
                  {...{ currentPage, limit, data, isNextPageAvailable, callback: this.goPage }}
                />
              ) : null}
            </>
          )}
        </S.WalletTransactions>
      </S.AccountWallet>
    );
  }
}

const mapStateToProps = ({
  AccountWallet: {
    isPending,
    error,
    startDate,
    endDate,
    activeTab,
    data,
    isNextPageAvailable,
    currentPage,
    limit,
  },
}) => {
  return {
    isPending,
    error,
    startDate,
    endDate,
    activeTab,
    data,
    isNextPageAvailable,
    currentPage,
    limit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchTransactionsByFilter: bindActionCreators(fetchTransactionsByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    resetToInitialState: bindActionCreators(resetToInitialState, dispatch),
    cancellPayout: bindActionCreators(cancellPayout, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountWallet);
